module.exports = __webpack_public_path__ + "static/media/left-arrow.8b79cf0d.svg";